import React from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryLinkButton } from '../button'
import { EmptyState } from '../ui'
import { HomeIcon } from '../icons'

export function Error404(): JSX.Element {
    const { t } = useTranslation()
    return (
        <div className='container mx-auto px-6 py-24'>
            <EmptyState
                icon={() => <p className='text-6xl font-bold text-gray-200'>404</p>}
                title={t('not-found.title')}
                subtitle={t('not-found.subtitle')}
                action={
                    <PrimaryLinkButton to='/'>
                        <HomeIcon size={1} className='mr-2' />
                        {t('shared.button.label.back-home')}
                    </PrimaryLinkButton>
                }
            />
        </div>
    )
}
